/**
 * Branding colours are chosen by instructors, not designers, so anything the
 * platform paints on top of --brand has to work out its own text colour. A
 * fixed white would vanish on a pale yellow; a fixed black would vanish on navy.
 */

function channel(v: number): number {
  const s = v / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}

export function relativeLuminance(hex: string): number {
  const clean = hex.replace('#', '');
  const full =
    clean.length === 3
      ? clean
          .split('')
          .map((c) => c + c)
          .join('')
      : clean.slice(0, 6);
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return 0;
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
}

function contrastWith(hex: string, luminance: number): number {
  const other = relativeLuminance(hex);
  const [hi, lo] = other > luminance ? [other, luminance] : [luminance, other];
  return (hi + 0.05) / (lo + 0.05);
}

/** Whichever of near-black / near-white contrasts better against `hex`. */
export function readableOn(hex: string): string {
  const l = relativeLuminance(hex);
  return contrastWith('#ffffff', l) >= contrastWith('#17150f', l) ? '#ffffff' : '#17150f';
}
